import Keycloak from "keycloak-js";
import { getEnvVariable } from "./env";

export const keycloakClient = new Keycloak({
  url: getEnvVariable("VITE_KEYCLOAK_URL"),
  realm: getEnvVariable("VITE_KEYCLOAK_REALM"),
  clientId: getEnvVariable("VITE_KEYCLOAK_CLIENT_ID"),
});

export const initKeycloak = () =>
  keycloakClient.init({
    onLoad: "login-required",
    checkLoginIframe: false,
    pkceMethod: "S256",
  });

export const callKeycloakLoginEndpoint = async (): Promise<void> => {
  const token = keycloakClient.token;
  if (token === undefined) return;

  const apiUrl = getEnvVariable("VITE_BACKEND_ENTRYPOINT_URL");

  try {
    await fetch(`${apiUrl}/keycloak-login`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error("Error calling /keycloak-login:", error);
  }
};
